import { useEffect, useState } from 'react'
import { cn } from '#app/utils/misc.tsx'

/**
 * Small ember dot that briefly pulses on each `pulseKey` change.
 * Used as a "fresh data" cue (e.g., after a re-parse or re-fetch).
 */
export function PulseDot({
	pulseKey = 0,
	className,
}: {
	pulseKey?: number
	className?: string
}) {
	const [pulsing, setPulsing] = useState(false)
	useEffect(() => {
		if (pulseKey === 0) return
		setPulsing(true)
		const t = setTimeout(() => setPulsing(false), 600)
		return () => clearTimeout(t)
	}, [pulseKey])
	return (
		<span
			aria-hidden
			className={cn(
				'inline-block h-1.5 w-1.5 rounded-full bg-ember align-middle',
				pulsing && 'animate-pulse',
				className,
			)}
		/>
	)
}
